import { useState, useCallback } from 'react';
import ServiceCollection from 'src/services/ServiceCollection';
import { FieldChanges } from 'src/models/AuditEvents';
import { VISIBLE_CHANGE_FIELDS } from 'src/components/data-registration/show-registration-record/definitions';

export const useGetAuditEventChanges = (services: ServiceCollection, registrationNumber: string) => {
  const [isGetAuditEventChangesLoading, setIsGetAuditEventChangesLoading] = useState(false);
  const [changes, setChanges] = useState<FieldChanges[] | null>(null);
  const [getAuditEventChangesError, setGetAuditEventChangesError] = useState<string | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const getAuditEventChanges = useCallback(
    async (lastUpdatedDateTime: string) => {
      setIsGetAuditEventChangesLoading(true);
      const { changes, error } = await services.auditService.getAuditEventChanges(
        registrationNumber,
        lastUpdatedDateTime,
      );
      if (error) {
        setGetAuditEventChangesError(error);
        return;
      }

      if (changes) {
        const filteredChanges: FieldChanges[] = [];

        for (const [key, value] of Object.entries(changes)) {
          if (key in VISIBLE_CHANGE_FIELDS) {
            filteredChanges.push({
              key: VISIBLE_CHANGE_FIELDS[key as keyof typeof VISIBLE_CHANGE_FIELDS],
              value: {
                oldValue: String(value.oldValue) === 'null' ? null : value.oldValue,
                newValue: String(value.newValue) === 'null' ? null : value.newValue,
              },
            });
          }
        }
        setChanges(filteredChanges);
        setIsGetAuditEventChangesLoading(false);
        setIsModalVisible(true);
      }
    },
    [services, registrationNumber],
  );

  const dismissModal = useCallback(() => {
    setIsModalVisible(false);
    setChanges(null);
  }, []);

  return {
    isGetAuditEventChangesLoading,
    changes,
    getAuditEventChangesError,
    isModalVisible,
    getAuditEventChanges,
    dismissModal,
  };
};
